module.exports = "<div class=\"layout_blank\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"